import { useCallback, useEffect, useRef, useState } from "react";

export const useAutoResetState = <T>(
	initial: T,
	durationMs: number,
): [T, (value: T) => void] => {
	const [value, setValue] = useState<T>(initial);
	const initialRef = useRef(initial);
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	useEffect(
		() => () => {
			if (timeoutRef.current !== null) {
				clearTimeout(timeoutRef.current);
			}
		},
		[],
	);

	const setTemporarily = useCallback(
		(next: T) => {
			if (timeoutRef.current !== null) {
				clearTimeout(timeoutRef.current);
			}
			setValue(next);
			timeoutRef.current = setTimeout(() => {
				timeoutRef.current = null;
				setValue(initialRef.current);
			}, durationMs);
		},
		[durationMs],
	);

	return [value, setTemporarily];
};
